import React from 'react';
import { Info, RotateCcw, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
export function ModelsPanel() {
  return <Card className="h-full flex flex-col overflow-hidden border-slate-700/50" data-id="element-621">
      <div className="flex items-center justify-between p-3 border-b border-slate-700/50 bg-slate-800/30" data-id="element-622">
        <div className="flex items-center gap-2" data-id="element-623">
          <h3 className="font-semibold text-sm text-slate-200" data-id="element-624">Models</h3>
          <Info size={14} className="text-slate-500" data-id="element-625" />
        </div>
        <Button size="sm" variant="ghost" className="h-6 px-2 text-xs gap-1" data-id="element-626">
          <RotateCcw size={12} data-id="element-627" />
          Reset
        </Button>
      </div>

      <div className="flex items-center justify-between px-3 py-2 bg-slate-800/20 border-b border-slate-700/30" data-id="element-628">
        <Button size="icon" variant="ghost" className="h-6 w-6" data-id="element-629">
          <ChevronLeft size={14} data-id="element-630" />
        </Button>
        <div className="text-xs font-medium text-slate-300" data-id="element-631">
          <span className="text-slate-500 mr-2" data-id="element-632">February</span>
          <span className="mx-1" data-id="element-633">11</span>
          <span className="mx-1 text-white font-bold" data-id="element-634">12</span>
          <span className="mx-1" data-id="element-635">13</span>
        </div>
        <Button size="icon" variant="ghost" className="h-6 w-6" data-id="element-636">
          <ChevronRight size={14} data-id="element-637" />
        </Button>
      </div>

      <div className="flex-1 p-3 space-y-2 overflow-y-auto" data-id="element-638">
        {[{
        name: 'EPT-2',
        time: '2026-02-11 06:00',
        active: true
      }, {
        name: 'EC IFS',
        time: '2026-02-11 06:00',
        active: true,
        color: 'blue'
      }, {
        name: 'EPT-1.5',
        active: false
      }, {
        name: 'EPT-1.5 Early',
        active: false
      }, {
        name: 'EPT-2 Early',
        active: false
      }, {
        name: 'EPT-2 Reasoning',
        active: false
      }, {
        name: 'NOAA GFS',
        active: false
      }].map((model, i) => <div key={i} className="flex items-center gap-3 text-xs" data-id="element-639">
            {model.active ? <Badge variant={model.color === 'blue' ? 'blue' : 'pink'} className="w-full justify-between py-1" data-id="element-640">
                <span data-id="element-641">{model.name}</span>
                <span className="opacity-70 font-mono" data-id="element-642">{model.time}</span>
                <button className="hover:text-white" data-id="element-643">
                  <span className="sr-only" data-id="element-644">Remove</span>×
                </button>
              </Badge> : <div className="flex items-center gap-3 w-full px-2 py-1 text-slate-400 hover:bg-slate-800/50 rounded cursor-pointer" data-id="element-645">
                <div className="h-2 w-2 rounded-full border border-slate-600" data-id="element-646" />
                <span data-id="element-647">{model.name}</span>
              </div>}
          </div>)}
      </div>
    </Card>;
}